<template lang="pug">
div
  div
    v-card-title
      span Plan alcanzable (SOM)
      ShowInfoBtn(@click="$refs.infoAlert.showAlert()")
      v-spacer
      v-btn.mr-2(color="primary" @click="$refs.salePlanItemByProductFormModal.openDialog()")
        v-icon(left) mdi-plus-circle-outline
        span MODIFICAR PLAN
      v-menu(offset-y)
        template(v-slot:activator="{ on, attrs }")
          v-btn(v-bind="attrs" v-on="on" color="primary")
            span acciones
            v-icon(right) mdi-menu-down
        v-list
          v-list-item(@click="$refs.importSalePlanFormModal.openDialog()")
            v-list-item-title.d-flex.primary--text.font-weight-medium.justify-space-between
              div
                v-icon(color="primary") mdi-file-upload
              div Cargar Masivo
          v-list-item(@click="handleExportSalePlan()" v-if="isStarted")
            v-list-item-title.d-flex.primary--text.font-weight-medium.justify-space-between
              div
                  v-icon(color="primary") mdi-download-circle
              div Exportar
          v-list-item(@click="$refs.salesPlanMonitoringForm.openDialog(projection || $route.params.id)" v-if="isStarted")
            v-list-item-title.d-flex.primary--text.font-weight-medium.justify-space-between Generar plan de venta para seguimiento
    v-card-text
        InfoAlert(:message="alertMessage" ref="infoAlert")
    StartSalePlanPanel(v-if="!isStarted" @start="$refs.importSalePlanFormModal.openDialog()")
    div(v-else)
      v-alert(v-if="optimalSales" dense text :color="captureColor" border="left" class="mx-4 mb-2")
        span(v-html="captureMessage")
      ChartSalePlan(:filters="filters" ref="chartSalePlan")
      TableSalePlan(:filters="filters" ref="tableSalePlan" @editItem="$refs.salePlanItemByProductFormModal.openDialog($event)")
  ImportSalePlanFormModal(ref="importSalePlanFormModal" @save="checkIfSalePlanStarted")
  SalePlanItemByProductFormModal(ref="salePlanItemByProductFormModal" @save="checkIfSalePlanStarted")
  SalesPlanMonitoringForm(ref="salesPlanMonitoringForm")
</template>

<script>
import StartSalePlanPanel from '@/components/commercial_projection/StartSalePlanPanel.vue'
import ImportSalePlanFormModal from '@/components/commercial_projection/ImportSalePlanFormModal.vue'
import ChartSalePlan from '@/components/commercial_projection/charts/ChartSalePlan.vue'
import TableSalePlan from '@/components/commercial_projection/charts/TableSalePlan.vue'
import SalePlanItemByProductFormModal from '@/components/commercial_projection/SalePlanItemByProductFormModal.vue'
import { mapActions } from 'vuex'
import { fmtMoneyMM } from '@/utils/customVueFilters'
import InfoAlert from '../common/InfoAlert.vue'
import ShowInfoBtn from '../common/ShowInfoBtn.vue'
import SalesPlanMonitoringForm from './SalesPlanMonitoringForm.vue'

export default {
  props: {
    filters: {
      type: Object,
      required: true,
      default: () => ({})
    },
    projection: {
      type: Number,
      default: null,
    },
  },
  components: {
    StartSalePlanPanel,
    ImportSalePlanFormModal,
    ChartSalePlan,
    TableSalePlan,
    SalePlanItemByProductFormModal,
    InfoAlert,
    ShowInfoBtn,
    SalesPlanMonitoringForm
  },
  data () {
    return {
      isStarted: false,
      loading: true,
      planSales: 0,
      optimalSales: 0,
      alertMessage: 'Este es tu <b>plan alcanzable (SOM)</b>: cuánto puedes vender de verdad este año, a partir del mix óptimo. Puedes importarlo del Mix Óptimo o ajustarlo a mano. Cuando esté listo, expórtalo al módulo de Seguimiento para controlar tus metas mes a mes.',
    }
  },
  computed: {
    pctCaptured() {
      return this.optimalSales ? (this.planSales / this.optimalSales) * 100 : 0
    },
    captureColor() {
      if (this.pctCaptured >= 98) return 'success'
      if (this.pctCaptured >= 80) return 'info'
      return 'warning'
    },
    captureMessage() {
      const pct = Math.round(this.pctCaptured)
      const money = fmtMoneyMM
      if (pct >= 98) return `Tu plan captura el <b>${pct}%</b> de tu venta óptima (${money(this.planSales)}): estás aprovechando prácticamente todo tu potencial rentable.`
      return `Tu plan captura el <b>${pct}%</b> de tu venta óptima (${money(this.planSales)} de ${money(this.optimalSales)}). Ajústalo para acercarte al óptimo.`
    },
  },
  methods: {
    ...mapActions('commercial_projection', ['listSalePlanItems', 'exportSalePlan', 'getStatisticsSalePlan', 'getOptimalMixStatistics']),
    async fetchComparison() {
      const params = { projection: this.projection || this.$route.params.id }
      const [planRes, optRes] = await Promise.all([
        this.getStatisticsSalePlan(params),
        this.getOptimalMixStatistics(params),
      ])
      if (!planRes.error && planRes.data) this.planSales = planRes.data.total_sales || 0
      if (!optRes.error && optRes.data) this.optimalSales = optRes.data.total_sales || 0
    },
    async handleExportSalePlan() {
      const params = {
        projection: this.projection || this.$route.params.id,
        ...this.filters
      }
      await this.exportSalePlan(params)
    },
    async checkIfSalePlanStarted() {
      this.loading = true
      const params = {
        projection: this.projection || this.$route.params.id
      }
      const { data } = await this.listSalePlanItems(params)

      if (data) {
        this.isStarted = data.count > 0
        if (this.isStarted) this.fetchComparison()
      }
      this.loading = false
    },
    updateData() {
      this.$refs.chartSalePlan.fetchData()
      this.$refs.tableSalePlan.fetchData()
    }
  },
  created() {
    this.checkIfSalePlanStarted()
  }
}
</script>
